import { BlogService } from './services/blog.service'
/* style */
import { NgModule, APP_INITIALIZER, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { CoreModule } from './core.module'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TransferHttpCacheModule } from '@nguniversal/common'
import { APP_BASE_HREF, DatePipe } from '@angular/common'
import { environment } from '../environments/environment'
import { DateThFormatPipe, NavigationModule, ReferrerService } from '@flowaccount/landing'
import { CookieService } from 'ngx-cookie-service'
import { SharedService } from '@flowaccount/landing'
import { NotfoundComponent } from './components/notfound/notfound.component'
import { StoreModule } from '@ngrx/store'
import { appStateReducer } from '@flowaccount/landing'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { PipesModule } from '@flowaccount/landing'
import { RecaptchaModule } from 'ng-recaptcha'
import { SitemapComponent } from './components/sitemap/sitemap.component'
import { ScullyLibModule } from '@scullyio/ng-lib'
import { ServiceWorkerModule } from '@angular/service-worker'
import { SEOService } from '@flowaccount/landing'
import { CustomTranslateModule } from '@flowaccount/landing'
// lazy load image
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { FaqService } from './services/faq.service'
import { AuthInterceptor } from './services/auth.interceptor'

export function provideSwal() {
  return import('sweetalert2/dist/sweetalert2.js') // instead of import('sweetalert2')
}

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'flowaccount-classic' }),
    BrowserAnimationsModule,
    BrowserTransferStateModule,
    StoreModule.forRoot({ appState: appStateReducer }),
    AppRoutingModule,
    CustomTranslateModule.forRoot(),
    CoreModule.forRoot(),
    TransferHttpCacheModule,
    HttpClientModule,
    PipesModule,
    NavigationModule,
    RecaptchaModule,
    ScullyLibModule,
    SweetAlert2Module.forRoot({ provideSwal }),
    ServiceWorkerModule.register('landing-worker.js', {
      enabled: environment.production,
    }),
    NavigationModule,
  ],
  declarations: [AppComponent, NotfoundComponent, SitemapComponent],
  providers: [
    BlogService,
    ReferrerService,
    SharedService,
    CookieService,
    FaqService,
    {
      provide: APP_BASE_HREF,
      useValue: environment.baseHref,
    },
    SEOService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
